<template>
  <label :class="['label', variant]" :for="inputId">{{ label }}</label>
</template>

<script setup lang="ts">

withDefaults(defineProps<{
  variant?: 'primary' | 'error',
  inputId: string
  label: string | undefined
}>(), {
  variant: 'primary'
});

</script>
<style lang="scss" scoped>
.label {
  font-family: Lato;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.error {
    padding-bottom: 4px;
    color: red;
  }
}
</style>
